"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTextMask = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var emailMask_1 = tslib_1.__importDefault(require("text-mask-addons/dist/emailMask"));
var Base_1 = require("../Base");
exports.EmailTextMask = function (props) { return (react_1.default.createElement(Base_1.TextMask, tslib_1.__assign({}, props, { mask: emailMask_1.default }))); };
exports.EmailTextMask.displayName = 'FOS_EmailTextMask';
